// Sanity CDN image transform helper (2026-07-18, homepage media-weight pass).
//
// PROBLEM: GROQ queries project `image.asset->url`, which is the ORIGINAL
// upload URL (e.g. cdn.sanity.io/.../...-2816x1536.jpg) with no transform
// params — three homepage blog-card images were ~2.2MB combined, served at
// 2048-2816px wide for containers that render <=800px.
//
// FIX: every Sanity-sourced <img src> goes through sanityImageUrl(), which
// appends the CDN's transform params:
//   auto=format → WebP/AVIF when the browser supports it
//   fit=max     → never upscale beyond the original
//   w=<width>   → cap to the rendered container (pass ~2x CSS width for
//                 retina; default 800 covers the common <=400px card)
//   q=75        → sane photographic quality
//
// Non-Sanity URLs (local /images/*, other hosts) pass through untouched,
// as do URLs that already carry a query string (assume caller knows best).
const SANITY_CDN_HOST = 'cdn.sanity.io';

export function sanityImageUrl(url, width = 800, quality = 75) {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes(SANITY_CDN_HOST)) return url;
  if (url.includes('?')) return url;
  return `${url}?auto=format&fit=max&w=${width}&q=${quality}`;
}

export default sanityImageUrl;
